import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import logo from '../../images/logo.svg';

function Intro({ setExceedError, setresetPassword }) {
  let navigate = useNavigate();
  const [isExceeded, setIsExceeded] = useState(false);
  const [timetoReset, setTimeToReset] = useState(false);
  const exceedLogin = () => {
    setIsExceeded(true);
    // navigate("/login",{state:{exceed:true}});
    setExceedError(true);
    setresetPassword(false);

  }
  const normalLogin = () => {
    setIsExceeded(false);
    // navigate("/login",{state:{exceed:false}});
    setExceedError(false);
    setresetPassword(false);
  }
  const resetPassword = () => {
    setTimeToReset(true);
    // navigate("/login",{state:{reset:true}})
    setresetPassword(true);
    setExceedError(false);
  }
  const resetToExceed = () => {
    setTimeToReset(false);
    // navigate("/login",{state:{reset:false,exceed:true}})
    setExceedError(true);
    setresetPassword(false);
  }
  return (
    <div className="login-content-section">
      <div className="row">
        <div className="col-sm-12">
          <div className="login-content-logo-section">
            <img className="login-content-logo" src={logo} alt={"logo"} />
            <div className="login-content-title">
              <h4 className="login-content-htitle">ईसीआई वेब पोर्टल</h4>
              <h4 className="login-content-etitle">ECI Web Portal</h4>
            </div>
          </div>
          <div className="login-content-para">
            <p className="p_login">The ecosystem of ECI portal which provide better personalization, user friendly, Geographic Navigation System, ease of sending notifications and digitization of offline work.</p>
          </div>
          {/* {!isExceeded && <span onClick={exceedLogin} className="tabs_login">Exceeded Login Error</span>}
          {isExceeded && <span onClick={normalLogin} className="tabs_login">Normal Login Screen</span>}
          {!timetoReset && <span onClick={resetPassword} className="tabs_login">Time to reset password</span>}
          {timetoReset && <span onClick={resetToExceed} className="tabs_login">Exceeded Login Error</span>} */}
          {/* <br />
          <br /> */}
          <span onClick={() => { navigate("/") }} className="tabs_login">Home</span>
          <span>About Us</span>
          <span>Contact Us</span>
        </div>
      </div>
    </div>
  );
}

export default Intro;